"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class EmailSentRecentlyError extends client_library_1.ExtendableError {
    constructor() {
        super('Email was sent too recently');
    }
}
exports.default = EmailSentRecentlyError;
//# sourceMappingURL=EmailSentRecentlyError.js.map